<template>
  <v-container>
    <v-row>
      <MobileCol>
        <v-skeleton-loader
          :loading="isLoading"
          transition="expand-transition"
          type="card"
        >
          <FormIncident
            ref="formIncident"
            :Incident="editIncident"
            :isSaving="isSaving"
            @save="save"
          />
        </v-skeleton-loader>
      </MobileCol>
    </v-row>
  </v-container>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormIncident from '../components/FormIncident.vue';
import MobileCol from '../components/MobileCol.vue';

export default {
  components: {
    FormIncident,
    MobileCol,
  },
  name: 'EditIncident',
  module: 'Membership',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing Incident. Default to {}.
      */
      editIncident: {},
      /**
       * Query Id for Incident
       */
      incidentId: this.$route?.query.id,
    };
  },
  computed: {
    google: gmapApi,
    /** Vuex states
     */
    ...mapState('incidents', ['incidents', 'incidentsInMyArea']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.incidentId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    if (this.mode === 'edit') {
      this.editIncident = await this.LOAD_incident(this.incidentId);
      const latLng = this.parseMapItemPoint(this.editIncident.location);
      this.$refs.formIncident.mapClick({
        latLng,
      });
      this.$refs.formIncident.$refs.map.panTo(latLng);
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('incidents', ['CREATE_incidentModel', 'LOAD_incident', 'UPDATE_incidentModel']),
    /** Method used parse server geography to google lantLng
     */
    parseMapItemPoint(point) {
      if (!point) {
        return undefined;
      }
      const coord = point?.geography?.wellKnownText?.replace('POINT ', '')
        .replace('(', '')
        .replace(')', '');
      const coordArr = coord.split(/[ ,]+/);
      const lat = parseFloat(coordArr[1]);
      const lng = parseFloat(coordArr[0]);
      // eslint-disable-next-line no-undef
      if (this.google) {
        const latLng = new this.google.maps.LatLng(lat, lng) ?? {};
        return latLng;
      }
      return {};
    },
    /** Method used to save the item
     */
    async save(incident) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_incidentModel(incident);
      } else {
        await this.UPDATE_incidentModel(incident);
      }
      this.isSaving = false;
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
      this.$router.push({ name: this.from.name });
    },
  },
};
</script>

<docs>
# EditIncident example

'''js
<EditIncident :Incident="Incident" />
'''
</docs>
